<template>
    <modal :show.sync=show modalClasses="modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Loan Information</h3>
        <b-row>
            <b-col cols="12">
              <div v-if="_gAuth.isAppSas()">
                <div v-if="tableData.length > 0" class="loan-information rounded-bottom">
                    <b-table-simple responsive bordered>
                        <b-thead>
                            <b-tr>
                                <b-th rowspan="2">No.</b-th>
                                <b-th rowspan="2">Date/R&R</b-th>
                                <b-th rowspan="2">STS</b-th>
                                <b-th rowspan="2">Capacity</b-th>
                                <b-th rowspan="2">Lender<br> Type</b-th>
                                <b-th rowspan="2">Facility</b-th>
                                <b-th rowspan="2">Total O/S<br> Balance (RM)</b-th>
                                <b-th rowspan="2">Date Balance<br> Updated</b-th>
                                <b-th rowspan="2">Limit/Instl.<br> Amt. (RM)</b-th>
                                <b-th rowspan="2">Prin. Rpmt.<br> Term</b-th>
                                <b-th rowspan="2">Col<br> Type</b-th>
                                <b-th colspan="12" class="pb-0">
                                    <div class="d-flex justify-content-between">
                                        Conduct of Acc. for Last 12 Months
                                        <small>(From {{ tableData[0].commitment_monthly[0].month_position_date + ' untill ' + tableData[0].commitment_monthly[11].month_position_date }})</small>
                                    </div>
                                </b-th>
                                <b-th rowspan="2">Lgl<br> Sts</b-th>
                                <b-th rowspan="2">Date Sta.<br> Updated</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th v-for="(month, index) in tableData[0].commitment_monthly" :key="month.month_id" class="pt-0 pb-1">{{ monthAbbreviation(month.month_month) + (index === 0 || index === 11 ? ' `' + month.month_year.toString().slice(-2) : '') }}</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-for="(item, index) in tableData" :key="item.commitment_id" class="text-center">
                            <b-tr>
                                <!-- <b-td>{{ index + 1 }}</b-td> -->
                                <b-td :style="{'background-color': isPTPTN(item) ? 'rgb(78,197,115)' : ''}">{{ index + 1 }}</b-td>
                                <b-td>{{ item.commitment_approved_date }}</b-td>
                                <b-td>{{ item.commitment_status }}</b-td>
                                <b-td>{{ item.commitment_capacity }}</b-td>
                                <b-td>{{ item.commitment_lender_type }}</b-td>
                                <b-td>{{ item.commitment_loan_statue }}</b-td>
                                <b-td>{{ item.commitment_current_outstanding === '0.00' ? '' : parseFloat(item.commitment_current_outstanding).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</b-td>
                                <b-td>{{ item.commitment_date_balance_updated }}</b-td>
                                <b-td>{{ item.commitment_credit_limit | moneyFormatter }}</b-td>
                                <b-td>{{ item.commitment_repay_term }}</b-td>
                                <b-td>{{ item.commitment_col_type }}</b-td>
                                <b-td v-for="conduct in item.commitment_monthly" :key="conduct.month_id">{{ conduct.month_inst_arrears }}</b-td>
                                <b-td>{{ item.commitment_legal_status }}</b-td>
                                <b-td>{{ item.commitment_legal_date }}</b-td>
                            </b-tr>
                            <b-tr v-for="sub_item in item.commitment_sub_items" :key="sub_item.commitment_id">
                                <b-td></b-td>
                                <b-td>{{ sub_item.commitment_approved_date === item.commitment_approved_date ? '' : sub_item.commitment_approved_date }}</b-td>
                                <b-td>{{ sub_item.commitment_status === item.commitment_status ? '' : sub_item.commitment_status }}</b-td>
                                <b-td>{{ sub_item.commitment_capacity === item.commitment_capacity ? '' : sub_item.commitment_capacity }}</b-td>
                                <b-td>{{ sub_item.commitment_lender_type === item.commitment_lender_type ? '' : sub_item.commitment_lender_type }}</b-td>
                                <b-td>{{ sub_item.commitment_loan_statue === item.commitment_loan_statue ? '' : sub_item.commitment_loan_statue }}</b-td>
                                <b-td>{{ sub_item.commitment_current_outstanding === item.commitment_current_outstanding || sub_item.commitment_current_outstanding === '0.00' ? '' : parseFloat(sub_item.commitment_current_outstanding ).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</b-td>
                                <b-td>{{ sub_item.commitment_date_balance_updated === item.commitment_date_balance_updated ? '' : sub_item.commitment_date_balance_updated }}</b-td>
                                <b-td>{{ sub_item.commitment_current_installment | moneyFormatter }}</b-td>
                                <b-td>{{ sub_item.commitment_repay_term === item.commitment_repay_term ? '' : sub_item.commitment_repay_term }}</b-td>
                                <b-td>{{ sub_item.commitment_col_type === item.commitment_col_type ? '' : sub_item.commitment_col_type }}</b-td>
                                <b-td v-for="conduct in sub_item.commitment_monthly" :key="conduct.month_id" :style="{'background-color': conduct.month_inst_arrears !== '0' && conduct.month_inst_arrears !== '' ? '#ffe7e7' : ''}">{{ conduct.month_inst_arrears }}</b-td>
                                <b-td>{{ sub_item.commitment_legal_status === item.commitment_legal_status ? '' : sub_item.commitment_legal_status }}</b-td>
                                <b-td>{{ sub_item.commitment_legal_date === item.commitment_legal_date ? '' : sub_item.commitment_legal_date }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
                <div v-else class="bg-light p-3 text-center rounded-bottom">
                  <p class="text-xs">No Loan Information recorded</p>
                </div>
              </div>
               <div v-else>
                 <div v-if="tableData.length > 0" class="loan-information rounded-bottom">
                    <b-table-simple responsive bordered>
                        <b-thead>
                            <b-tr>
                                <b-th rowspan="2">No.</b-th>
                                <b-th rowspan="2">Date/R&R</b-th>
                                <b-th rowspan="2">STS</b-th>
                                <b-th rowspan="2">Capacity</b-th>
                                <b-th rowspan="2">Lender<br> Type</b-th>
                                <b-th rowspan="2">Facility</b-th>
                                <b-th rowspan="2">Total O/S<br> Balance (RM)</b-th>
                                <b-th rowspan="2">Date Balance<br> Updated</b-th>
                                <b-th rowspan="2">Limit/Instl.<br> Amt. (RM)</b-th>
                                <b-th rowspan="2">Prin. Rpmt.<br> Term</b-th>
                                <b-th rowspan="2">Col<br> Type</b-th>
                                <b-th colspan="12" class="pb-0">
                                    <div class="d-flex justify-content-between">
                                        Conduct of Acc. for Last 12 Months
                                        <small>(From {{ tableData[0].commitment_monthly[0].month_position_date + ' untill ' + tableData[0].commitment_monthly[11].month_position_date }})</small>
                                    </div>
                                </b-th>
                                <b-th rowspan="2">Lgl<br> Sts</b-th>
                                <b-th rowspan="2">Date Sta.<br> Updated</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th v-for="(month, index) in tableData[0].commitment_monthly" :key="month.month_id" class="pt-0 pb-1">{{ monthAbbreviation(month.month_month) + (index === 0 || index === 11 ? ' `' + month.month_year.toString().slice(-2) : '') }}</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-for="(item, index) in tableData" :key="item.commitment_id" class="text-center">
                            <b-tr>
                                <!-- <b-td>{{ index + 1 }}</b-td> -->
                                <b-td :style="{'background-color': isPTPTN(item) ? 'rgb(78,197,115)' : ''}">{{ index + 1 }}</b-td>
                                <b-td>{{ item.commitment_approved_date }}</b-td>
                                <b-td>{{ item.commitment_status }}</b-td>
                                <b-td>{{ item.commitment_capacity }}</b-td>
                                <b-td>{{ item.commitment_lender_type }}</b-td>
                                <b-td>{{ item.commitment_loan_statue }}</b-td>
                                <b-td>{{ item.commitment_current_outstanding === '0.00' ? '' : parseFloat(item.commitment_current_outstanding).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</b-td>
                                <b-td>{{ item.commitment_date_balance_updated }}</b-td>
                                <b-td>{{ item.commitment_credit_limit | moneyFormatter }}</b-td>
                                <b-td>{{ item.commitment_repay_term }}</b-td>
                                <b-td>{{ item.commitment_col_type }}</b-td>
                                <b-td v-for="conduct in item.commitment_monthly" :key="conduct.month_id">{{ conduct.month_inst_arrears }}</b-td>
                                <b-td>{{ item.commitment_legal_status }}</b-td>
                                <b-td>{{ item.commitment_legal_date }}</b-td>
                            </b-tr>
                            <b-tr v-for="sub_item in item.commitment_sub_items" :key="sub_item.commitment_id">
                                <b-td></b-td>
                                <b-td>{{ sub_item.commitment_approved_date === item.commitment_approved_date ? '' : sub_item.commitment_approved_date }}</b-td>
                                <b-td>{{ sub_item.commitment_status === item.commitment_status ? '' : sub_item.commitment_status }}</b-td>
                                <b-td>{{ sub_item.commitment_capacity === item.commitment_capacity ? '' : sub_item.commitment_capacity }}</b-td>
                                <b-td>{{ sub_item.commitment_lender_type === item.commitment_lender_type ? '' : sub_item.commitment_lender_type }}</b-td>
                                <b-td>{{ sub_item.commitment_loan_statue === item.commitment_loan_statue ? '' : sub_item.commitment_loan_statue }}</b-td>
                                <b-td>{{ sub_item.commitment_current_outstanding === item.commitment_current_outstanding || sub_item.commitment_current_outstanding === '0.00' ? '' : parseFloat(sub_item.commitment_current_outstanding ).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</b-td>
                                <b-td>{{ sub_item.commitment_date_balance_updated === item.commitment_date_balance_updated ? '' : sub_item.commitment_date_balance_updated }}</b-td>
                                <b-td>{{ sub_item.commitment_current_installment | moneyFormatter }}</b-td>
                                <b-td>{{ sub_item.commitment_repay_term === item.commitment_repay_term ? '' : sub_item.commitment_repay_term }}</b-td>
                                <b-td>{{ sub_item.commitment_col_type === item.commitment_col_type ? '' : sub_item.commitment_col_type }}</b-td>
                                <b-td v-for="conduct in sub_item.commitment_monthly" :key="conduct.month_id" :style="{'background-color': conduct.month_inst_arrears !== '0' && conduct.month_inst_arrears !== '' ? '#ffe7e7' : ''}">{{ conduct.month_inst_arrears }}</b-td>
                                <b-td>{{ sub_item.commitment_legal_status === item.commitment_legal_status ? '' : sub_item.commitment_legal_status }}</b-td>
                                <b-td>{{ sub_item.commitment_legal_date === item.commitment_legal_date ? '' : sub_item.commitment_legal_date }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
                <div v-else class="loan-information rounded-bottom">
                  <b-table-simple responsive bordered>
                    <b-thead>
                      <b-tr>
                        <b-th rowspan="2">No.</b-th>
                        <b-th rowspan="2">Date/R&R</b-th>
                        <b-th rowspan="2">STS</b-th>
                        <b-th rowspan="2">Capacity</b-th>
                        <b-th rowspan="2">Lender<br> Type</b-th>
                        <b-th rowspan="2">Facility</b-th>
                        <b-th rowspan="2">Total O/S<br> Balance (RM)</b-th>
                        <b-th rowspan="2">Date Balance<br> Updated</b-th>
                        <b-th rowspan="2">Limit/Instl.<br> Amt. (RM)</b-th>
                        <b-th rowspan="2">Prin. Rpmt.<br> Term</b-th>
                        <b-th rowspan="2">Col<br> Type</b-th>
                        <b-th colspan="12" class="pb-0">
                          <div class="d-flex justify-content-between">
                            Conduct of Acc. for Last 12 Months
                            <small>(No data available)</small>
                          </div>
                        </b-th>
                        <b-th rowspan="2">Lgl<br> Sts</b-th>
                        <b-th rowspan="2">Date Sta.<br> Updated</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th v-for="n in 12" :key="n" class="pt-0 pb-1">{{ ['J','F','M','A','M','J','J','A','S','O','N','D'][n-1] }}</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td colspan="27" class="text-center text-muted py-3">Outstanding Credit</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
               </div>
            </b-col>
        </b-row>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
export default {
    props:{
        loanInformation: Array,
        show_loan_info_full_view: Boolean
        
    },
    components: {
        Modal
    },
    data() {
        return {
            tableData: this.loanInformation
        }
    },
    computed: {
        show: {
            get() {
                return this.show_loan_info_full_view;
            },
            set(value) {
                this.$emit('update:show_loan_info_full_view', value);
            }
        },
        monthAbbreviation() {
            return function (monthNumber) {
                switch (monthNumber) {
                case 1:
                    return 'J';
                case 2:
                    return 'F';
                case 3:
                    return 'M';
                case 4:
                    return 'A';
                case 5:
                    return 'M';
                case 6:
                    return 'J';
                case 7:
                    return 'J';
                case 8:
                    return 'A';
                case 9:
                    return 'S';
                case 10:
                    return 'O';
                case 11:
                    return 'N';
                case 12:
                    return 'D';
                default:
                    return '';
                }
            };
        }
    },
    methods: {
        isPTPTN(item) {
            // Check if commitment_org1 is "PT" (PTPTN)
            return item.commitment_org1 === 'PT';
        }
    },
    // mounted() {
    //     // debug logs to inspect incoming data when modal is mounted
    //     console.log('[LoanInformationModal] mounted - loanInformation:', this.loanInformation);
    //     console.log('[LoanInformationModal] mounted - tableData:', this.tableData);
    //     // headerMonths and commitmentRange are computed and helpful for header rendering
    //     console.log('[LoanInformationModal] mounted - headerMonths:', this.headerMonths);
    //     console.log('[LoanInformationModal] mounted - commitmentRange:', this.commitmentRange);
    // }
}
</script>